<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
/* global alert */

import config from './services/config'
import auth from './services/auth'
import router from './router'

export default {
  name: 'app',
  data() {
    return {
      loginError: null
    }
  },
  methods: {
    ping() {
      var self = this

      if (auth.user.authenticated) {
        if (auth.isTokenExpired() || !auth.getToken()) {
          auth.logout()
          setTimeout(function() {
            self.ping()
          }, 10000)
          router.push('/')
        } else {
          var chkDate = new Date(auth.getTokenExpirationDate())
          var sysDate = new Date()

          chkDate.setSeconds(chkDate.getSeconds() - 600)

          if (sysDate.valueOf() > chkDate.valueOf()) {
            this.$http
              .post(config.REFRESH_URL, {
                token: auth.getToken()
              })
              .then(
                response => {
                  auth.login(response.data.token)
                  setTimeout(function() {
                    self.ping()
                  }, 10000)
                },
                err => {
                  alert('Óvænt villa (' + err.status + ') kom upp. Vinsamlegast reyndu aftur.')
                }
              )
          } else {
            setTimeout(function() {
              self.ping()
            }, 10000)
          }
        }
      } else {
        setTimeout(function() {
          self.ping()
        }, 10000)
      }
    }
  },
  created: function() {
    this.ping()
  }
}
</script>

<style lang="scss">
@import 'style/bootstrap';
@import 'style/main';
@import 'style/main';
@import 'style/privacyPolicy';
</style>
